/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:6e1ebcf8-cce2-434c-a0f5-aef5b18a7ae1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Ey2t8MkAN",
    "aws_user_pools_web_client_id": "1fa3164jo58ahg5vb9n9eu7vtc",
    "oauth": {}
};


export default awsmobile;
